export default __webpack_public_path__ + "0c341a8a03fffd06a37c16fa53cb0c34.png";